import { Link } from "react-router-dom";
import { Container, Home } from './style'

export const PageNotFound = () => (
  <Container>
    <Home>
      <Link to="/" tabIndex={99}>
        Home
      </Link>
    </Home>

    <h1>404: Page not found</h1>
  </Container>
);
